import React from "react";
import { FileText, Download, Calendar } from "lucide-react";
import PageBanner from "../components/PageBanner";
import Reveal from "../components/Reveal";
import { useToast } from "../hooks/use-toast";
import { newsItems, resources } from "../mock";

const NewsPage = () => {
  const { toast } = useToast();
  const handleDownload = (title) =>
    toast({
      title: "Resource requested",
      description: `"${title}" — downloads will be available once connected to the backend.`,
    });

  return (
    <>
      <PageBanner
        title="News & Events"
        subtitle="Trade missions, delegations and engagements — a record of Continex in action."
        crumbs={[{ label: "News & Events" }]}
      />

      <section className="bg-white py-20 md:py-24">
        <div className="mx-auto max-w-7xl px-4 md:px-8">
          <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
            {newsItems.map((n, i) => (
              <Reveal key={n.id} delay={i * 100}>
                <article className="group flex h-full flex-col overflow-hidden rounded-2xl border border-slate-100 shadow-[0_10px_40px_-24px_rgba(15,42,74,0.35)] transition-shadow duration-300 hover:shadow-[0_24px_60px_-28px_rgba(15,42,74,0.45)]">
                  <div className="h-48 overflow-hidden">
                    <img
                      src={n.image}
                      alt={n.title}
                      className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                    />
                  </div>
                  <div className="flex flex-1 flex-col p-6">
                    <div className="mb-3 flex items-center gap-1.5 text-xs font-medium text-[#E4545F]">
                      <Calendar className="h-4 w-4" /> {n.date}
                    </div>
                    <h3 className="text-base font-semibold leading-snug text-[#0F2A4A]">
                      {n.title}
                    </h3>
                    <p className="mt-3 flex-1 text-sm leading-relaxed text-slate-600">
                      {n.excerpt}
                    </p>
                  </div>
                </article>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-[#F6F7F9] py-20 md:py-24">
        <div className="mx-auto max-w-7xl px-4 md:px-8">
          <Reveal className="mb-12">
            <span className="text-xs font-semibold uppercase tracking-[0.22em] text-[#E4545F]">
              Resource Centre
            </span>
            <h2 className="mt-3 text-3xl font-semibold tracking-tight text-[#0F2A4A] md:text-4xl">
              Case studies & guides
            </h2>
          </Reveal>
          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {resources.map((r) => (
              <div
                key={r.id}
                className="group flex items-center justify-between gap-4 rounded-xl border border-slate-100 bg-white p-5 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-lg"
              >
                <div className="flex items-center gap-4">
                  <div className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-[#0F2A4A]/5 text-[#0F2A4A] transition-colors duration-300 group-hover:bg-[#0F2A4A] group-hover:text-white">
                    <FileText className="h-5 w-5" />
                  </div>
                  <span className="text-sm font-medium text-[#0F2A4A]">{r.title}</span>
                </div>
                <button
                  onClick={() => handleDownload(r.title)}
                  aria-label="download"
                  className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-full text-[#0F2A4A] transition-colors duration-200 hover:bg-[#0F2A4A] hover:text-white"
                >
                  <Download className="h-4 w-4" />
                </button>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default NewsPage;
